<footer class="site-footer">
  <div class="footer-inner">
    <a class="footer-brand" href="/">
      <img class="footer-brand-logo" src="/images/orderyaa-footer.png" alt="orderYaa" />
    </a>

    <div class="footer-columns">
      <ul class="footer-col">
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a routerLink="/privacy-policy">Privacy policy</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <ul class="footer-col">
        <li><a href="#rider">Become a rider</a></li>
        <li><a [href]="partnerUrl" target="_blank" rel="noopener">Register your store</a></li>
        <li><a href="#">How its work</a></li>
      </ul>

      <div class="footer-social">
        <span class="footer-social-title">Follow us on</span>
        <div class="footer-social-icons">
          <a
            href="https://www.instagram.com/p/Dcs-W-5gFDT/?utm_source=ig_web_button_share_sheet&igsi=MzRlODBiNWFlZA=="
            target="_blank"
            rel="noopener"
            aria-label="Instagram"
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" stroke-width="1.8" />
              <circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.8" />
              <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" />
            </svg>
          </a>
          <a href="https://www.facebook.com/share/p/1HGDRwhyoX/" target="_blank" rel="noopener" aria-label="Facebook">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15 8.5h2V5.5h-2c-2.2 0-4 1.8-4 4V12H9v3h2v5h3v-5h2.2l.8-3H14v-2.5c0-.55.45-1 1-1Z"
                fill="currentColor"
              />
            </svg>
          </a>
          <a
            href="https://www.linkedin.com/company/tech-colleagues/posts/"
            target="_blank"
            rel="noopener"
            aria-label="LinkedIn"
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" stroke-width="1.8" />
              <circle cx="8" cy="8.5" r="1.1" fill="currentColor" />
              <path d="M8 11.5v6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
              <path
                d="M12 17.5v-3.7c0-1.3 1-2.3 2.3-2.3s2.2 1 2.2 2.3v3.7"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
              />
              <path d="M12 11.5v6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-bottom">Copyright &copy; 2026 <a href="/">orderYaa</a></div>
</footer>
